import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/{-$locale}')({
  beforeLoad: ({ params }) => {
    const { locale } = params;
    console.log('beforeLoad locale', locale);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
